import React, { ReactNode } from "react"
import { Alert as MAlert } from "@mui/material"
import clsx from "clsx"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import styles from "./Alert.module.css"

export default function Alert({
  $type = "error",
  $small,
  children,
  className = "",
  style = {},
  ...rest
}: BaseStyles & {
  $type: "success" | "warning" | "error"
  $small?: boolean
  children: ReactNode
  className?: string
  style?: React.CSSProperties
}) {
  const generatedStyles = generateStylesFromProps(rest)

  const wrapperClasses = clsx(
    styles.wrapper,
    {
      [styles.small]: $small,
      [styles.error]: $type === "error",
      [styles.warning]: $type === "warning",
      [styles.success]: $type === "success",
    },
    className,
  )

  const wrapperStyles = {
    ...generatedStyles,
    ...style,
  }

  return (
    <div className={wrapperClasses} style={wrapperStyles}>
      <MAlert severity={$type}>{children}</MAlert>
    </div>
  )
}
